// What we call a meeting in the UI.
//
// Zoom's own topic is useless for most of our calls: personal-meeting-room
// links all report "<Name>'s Personal Meeting Room" and scheduled ad-hoc calls
// report "Zoom Meeting", so the list reads as a wall of identical rows. Zoom's
// `summary_title` is no better — it's boilerplate ("Meeting Summary for
// <topic>"). Attendees are the one thing that actually distinguishes those
// calls, so for generic topics we title by who was there.
//
// A real topic ("Lightcraft Office Hours", "Spark Dev Weekly") always wins —
// someone chose it deliberately. A name given in Atomic (custom_title) wins over
// everything, for the same reason and more so (LCCRM-88).

const GENERIC_TOPIC =
  /^(zoom meeting|my meeting|.*'s (personal meeting room|zoom meeting)|personal meeting room)$/i;

export const isGenericTopic = (topic: string | null | undefined): boolean => {
  const t = (topic ?? "").trim();
  return t === "" || GENERIC_TOPIC.test(t);
};

/** "Elijah, Jim, Liv" — or "Elijah, Jim, Liv +2" past three. */
export const namesTitle = (names: string[], max = 3): string => {
  const firsts: string[] = [];
  for (const n of names) {
    const first = (n ?? "").trim().split(/\s+/)[0];
    if (first && !firsts.includes(first)) firsts.push(first);
  }
  if (firsts.length === 0) return "";
  const shown = firsts.slice(0, max).join(", ");
  return firsts.length > max ? `${shown} +${firsts.length - max}` : shown;
};

export const meetingDisplayTitle = (
  record?: {
    custom_title?: string | null;
    meeting_topic?: string | null;
    participant_names?: string[] | null;
  } | null,
): string => {
  const custom = (record?.custom_title ?? "").trim();
  if (custom) return custom;
  const topic = (record?.meeting_topic ?? "").trim();
  if (!isGenericTopic(topic)) return topic;
  const names = namesTitle(record?.participant_names ?? []);
  return names || topic || "Zoom Meeting";
};
